export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/1YDTWeE3wfeZidnSHJJhRR/IMG_2579.jpg',
    alt: 'Sample page C-Rate: Normalized Current, with a 100 Ah battery example at 0.5C, 1C and 2C',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nN8ucMtzjp85udexsKB43k/IMG_2580.jpg',
    alt: 'Sample page High-Power vs. High-Energy Applications comparing power capability and energy capacity',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eE2Mdrrg1xwmxe8DZUoosm/IMG_2581.jpg',
    alt: 'Sample page Chapter 5: Battery Performance Characteristics, explaining nominal voltage',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pmc1zZGDYP6RW6pSZFJvaN/IMG_2582.jpg',
    alt: 'Sample page Parallel Connections: Capacity Adds, with four 100 Ah cells in parallel',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bHLkXTd2SwxFj2zWda2EYm/IMG_2583.jpg',
    alt: 'Sample page Voltage — Electrical Potential Difference, illustrated with two water towers',
  },
];
